import { Sprite } from 'pixi.js';

import { Shared } from '../../App';

export class BillboardIcon extends Sprite
{
    public highlighted = false;
    public orientation = 1;

    constructor(image: string, orientation = 1)
    {
        super();
        this.texture = Shared.assets.getTexture(image);
        this.anchor.set(0.5);
        this.scale.x = this.orientation = orientation;
    }

    public async highlight(): Promise<void>
    {
        if (this.highlighted) return;
        this.highlighted = true;
        Shared.game.tween.kill(this.scale);
        await Shared.game.tween.to(this.scale, { x: 1.25 * this.orientation, y: 1.25, duration: 0.4, ease: 'back.out' });
    }

    public async normal(): Promise<void>
    {
        if (!this.highlighted) return;
        this.highlighted = false;
        Shared.game.tween.kill(this.scale);
        await Shared.game.tween.to(this.scale, { x: this.orientation, y: 1, duration: 0.4, ease: 'back.out' });
    }

    public async spin(direction = 1, duration = 1): Promise<void>
    {
        Shared.game.tween.kill(this);
        await Shared.game.tween.to(this, { rotation: Math.PI * 2 * direction, duration, ease: 'sine.inOut' });
        this.rotation = 0;
    }
}
